import React, { useEffect, useState } from 'react';
import axios from 'axios';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Header_2026, Footer_2026, Ideas_inicio_2026, Ideas_ideas_2026, Ideas_suscripbion_2026 } from '../container';
import Modal_prue from '../components/modal2026/Modal';
import ModalVideo_prue from "../components/modal2026/ModalVideo.jsx";
import { useTranslation } from "react-i18next";

const IdeaCorta = () => {
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(window.location.search);
  const idiomaliga = queryParams.get("idea");
  const [t, i18n] = useTranslation("ideaCorta");


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [id_liga, setId_liga] = useState("");
  const [variable1, setVariable1] = useState("");
  const [variable2, setVariable2] = useState("");
  const [variable3, setVariable3] = useState("");
  const [idVideo, setidVideo] = useState("");
  const [isOpenModalVideo, setIsOpenModalVideo] = useState(false);
  const [urlVideo, setUrlVideo] = useState("");

  const closeModal = () => {
    setVariable1("");
    setVariable2("");
    setIsModalOpen(false);
  };

  const openModal = (value1, value2, value3, value4, value5) => {
    setVariable1(value1);
    setVariable2(value2);
    setVariable3(value5);
    setId_liga(value4);
    setIsModalOpen(true);
  };

  const openModalVideo = (contenido, id) => {
    setUrlVideo(contenido);
    setIsOpenModalVideo(true);
    setidVideo(id);
  };

  const closeModalVideo = () => {
    setUrlVideo("");
    setIsOpenModalVideo(false);
    setidVideo("");
  };

  useEffect(() => {
    if (idiomaliga) {
      axios.get(`https://www.ricardosalinas.com/S8JFmpfeLW5iUVROXz2owTPU/api/ideas/searchbyId?id=${idiomaliga}&lang=es`)
        .then(response => {
          const data = response.data[0]; // Asumiendo que siempre hay solo un elemento en el array
          console.log(data);

          if (data.tipo === "texto-imagen") {
            openModal(data.contenido, "texto-imagen", data.preview, idiomaliga, data.titulo);
          } else if (data.tipo === "texto-video") {
            if (data.id === 89) {
              openModal(data.contenido, "texto-imagen", data.preview, idiomaliga, data.titulo);
            }
            else {
              openModal(data.contenido, "", data.preview, idiomaliga, data.titulo);
            }
          } else if (data.tipo === "carrete") {
            openModal(data.contenido, "carrete", data.preview, idiomaliga, data.titulo);
          } else if (data.tipo === "texto") {
            openModal(data.contenido, "texto", "", idiomaliga, data.titulo);
          } else if (data.tipo === "imagen") {
            openModal("https://www.ricardosalinas.com"+data.preview, "imagen", data.preview, idiomaliga, "");
          } else if (data.tipo === "youtube") {
            openModalVideo(data.contenido, data.id);
          } else if (data.tipo === "video") {
            openModal("https://www.ricardosalinas.com" + data.contenido, "video", data.preview, idiomaliga, data.titulo);
          } else {
            console.log("Tipo incorrecto");
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
    // Dependencia vacía para que se ejecute solo una vez al montar el componente
  }, []);

  return (
    <div className="App_DB _nghost-ng-c2574764019 reflexiones-section">
      <Header_2026 />


      <Ideas_inicio_2026 />
      <Ideas_ideas_2026 />
      <Ideas_suscripbion_2026 />
      {/* <Header_ICor />
      <FiltroIdeCort />
      */}

      <Modal_prue
        isOpen={isModalOpen}
        closeModal={closeModal}
        variable1={variable1}
        id_idea={id_liga}
        variable2={variable2}
        variable3={variable3}
      />

      <ModalVideo_prue
        isOpen={isOpenModalVideo}
        closeModal={closeModalVideo}
        urlVideo={urlVideo}
        id_idea={idVideo}
      />
      <Footer_2026 />

    </div>
  );
};

export default IdeaCorta;